import { render, staticRenderFns } from "./InformationDeviceComponent.vue?vue&type=template&id=2f5dbf60&"
import script from "./InformationDeviceComponent.vue?vue&type=script&lang=js&"
export * from "./InformationDeviceComponent.vue?vue&type=script&lang=js&"
import style0 from "./InformationDeviceComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports